export const isEmpty = <T>(value: T | undefined | null): value is undefined | null => {
   if (value === null || value === undefined) {
      return true;
   }

   if (typeof value === 'string' || typeof value === 'number') {
      return value.toString().trim() === '';
   }

   if (Array.isArray(value)) {
      return value.length === 0;
   }

   if (value instanceof Map || value instanceof Set) {
      return value.size === 0;
   }

   if (typeof value === 'object') {
      return Object.keys(value).length === 0;
   }

   return false;
};
